var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.initLayout)?_c('set-list-link',{attrs:{"listLayout":_vm.listLayout,"setData":_vm.List,"paginationData":_vm.filterSet.page,"setType":_vm.setType,"originData":_vm.originData}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }